













import { Component, Prop, Watch } from 'vue-property-decorator'
import Vue from 'vue'
import { FramePuzzleModule } from '../../../store/modules/framePuzzle'
import { ErrorPayload, ErrorsModule } from '@/store/modules/error'
import i18n from '@/i18n'

@Component({
    name: "primary-buttons"
})

export default class PrimaryButtons extends Vue {
    @Prop() private confirmable!: boolean | Promise<boolean>

    confirmAvailable: boolean = false

    get emptyCollage() {
        return ErrorsModule.keys.includes('emptyCollage')
    }

    @Watch('confirmable')
    confirmableChanged(confirmable: boolean | Promise<boolean>) {
        window.console.log('confirmableChanged')
        this.handleConfirmable(confirmable)
    }

    onCancel() {
        this.$emit('cancel')
    }

    onConfirm() {
        this.$emit('confirm')
    }

    handleConfirmable(confirmable: boolean | Promise<boolean>) {
        if (confirmable instanceof Promise) {
            confirmable.then(c => { this.confirmAvailable = c })
        } else {
            this.confirmAvailable = confirmable
        }
    }

    mounted() {
        this.handleConfirmable(this.confirmable)
    }
}
